<template>
  <div class="app-container">
    <iframe
      id="iframe"
      :src="iframeSrc"
      height="100%"
      width="100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
const baseUrl = process.env.VUE_APP_PURCHASE_API
export default {
  name: 'SupplierAnalysisDetail',

  data() {
    return {
      iframeSrc: ''
    }
  },

  computed: {
    supplierId() {
      return this.$route.query.supplierId || ''
    }
  },

  created() {
    if (this.supplierId) {
      this.iframeSrc =
        baseUrl +
        `/bi/monitor/supplier-analysis/detail?supplierId=${this.supplierId}`
    }
  }
}
</script>

<style scoped lang="scss">
.data-box {
  display: inline-block;
  height: 14px;
  line-height: 14px;
}
</style>
